var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasLabel ||
    _vm.isBundle ||
    _vm.isSet ||
    !_vm.isSalable ||
    _vm.selectedVariation_tags
    ? _c(
        "div",
        { staticClass: "p-2", class: _vm.badgeClass },
        [
          _vm.hasLabel
            ? _c("span", { staticClass: "badge", class: _vm.tagClass }, [
                _vm._v("\n    " + _vm._s(_vm.label) + "\n  "),
              ])
            : _vm.isBundle
            ? _c("span", { class: _vm.tagClasses.itemBundle }, [
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.$translate("Ceres::Template.itemBundle")) +
                    "\n  "
                ),
              ])
            : _vm.isSet
            ? _c("span", { class: _vm.tagClasses.itemSet }, [
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.$translate("Ceres::Template.itemSet")) +
                    "\n  "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isSalable && _vm.displayAvBadge
            ? _c("span", { class: "badge badge-" + _vm.badgeAvailableClass }, [
                _vm._v("\n    " + _vm._s(_vm.badgeAvailableText) + "\n  "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.selectedVariation_tags, function (variationTag) {
            return [
              _vm.enableTagBadge && variationTag.names.name
                ? _c(
                    "span",
                    { class: "badge badge-info badge-id" + variationTag.id },
                    [
                      _vm._v(
                        "\n      TN:" +
                          _vm._s(variationTag.names.name) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v("TNXX:" + _vm._s(variationTag.names.name))]),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }